import React, {useState, useEffect, useRef } from "react";
import { ConnectNotificationBanner, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { CloudFunctions } from "../../FirebaseAuth/firebase";
import { useTheme } from '@mui/material/styles';

const NotificationBanner = ({accountId}) => {
    const mountedRef = useRef(true);
    const theme = useTheme();

    const [stripeConnectInstance] = useState(() => {
        const fetchSessionSecret = async () => {
            const response = await CloudFunctions.httpsCallable('fetchSessionSecret')({account_id: accountId, type: 'notification_banner'});
            const {error} = response.data;
            if(error!==undefined){
                // Handle errors on the client side here
                console.error('An error occurred: ', error);
                return undefined;
            } else {
                const {client_secret: clientSecret} = response.data;
                return clientSecret;
            }
        }
    
        return loadConnectAndInitialize({
          // This is your test publishable API key.
          publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          fetchClientSecret: fetchSessionSecret,
          appearance: {
            overlays: "dialog",
            variables: {
                colorText: theme.palette.grey[800],
                colorSecondaryText: theme.palette.text.secondary,
                colorBorder: theme.palette.divider,
                colorBackground: theme.palette.grey[50],
                actionPrimaryColorText: theme.palette.grey[800],
                actionSecondaryColorText: theme.palette.text.secondary,
                buttonPrimaryColorBackground: theme.palette.background.default,
                buttonSecondaryColorBackground: theme.palette.background.paper,
                offsetBackgroundColor: theme.palette.background.paper,
                formBackgroundColor: theme.palette.background.paper,
                spacingUnit: "8px",
                fontSizeBase: "16px",
                headingXlTextTransform: "none"
                },
            }
        })
    });
    const [display, setDisplay] = useState("none");

    const handleNotificationsChange = (response) => {
        if (response.actionRequired > 0) {
            // Do something related to required actions, such as adding margins to the banner container or tracking the current number of notifications.
            setDisplay("flex");
        } else if (response.total > 0) {
            // Do something related to notifications that don't require action.
            setDisplay("flex");
        } else {
            setDisplay("none");
        }
    };

    const onLoadError = (loadError) => {
        const componentName = loadError.elementTagName
        const error = loadError.error
        console.log(componentName + " failed to load")
        console.log(`${error.type}: ${error.message}`);
    };

    useEffect(() => {
        return () => { 
            mountedRef.current = false
        }
    },[]);

    return (
        <div style={{ display: display, margin: 0, padding: 0, marginTop: '16px' }}>
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                <ConnectNotificationBanner
                    collectionOptions={{
                        fields: 'eventually_due',
                        futureRequirements: 'include',
                    }}
                    onNotificationsChange={handleNotificationsChange}
                    onLoadError={onLoadError}
                />
            </ConnectComponentsProvider>
        </div>
    )
}

export default NotificationBanner;